/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type UpdateSubscriberContactDto = {
    name?: string;
    email?: string;
    phoneNumber?: string;
    customSlot?: string;
    selectedDays?: Array<string>;
    whatWouldWorkBetter?: string;
    additionalInfo?: string;
    language: UpdateSubscriberContactDto.language;
    wantsToBeContacted?: boolean;
    hasBooked?: boolean;
    firstTime?: boolean;
};

export namespace UpdateSubscriberContactDto {

    export enum language {
        EN = 'en',
        SV = 'sv',
        DE = 'de',
        DA = 'da',
    }


}

